const prefix = "app/ReportsV2/WidgetResume"

export const GET_EVOLUTION_MEASURE_WATCHER = `${prefix}/GET_EVOLUTION_MEASURE_WATCHER`
export const GET_EVOLUTION_MEASURE_SUCCESS = `${prefix}/GET_EVOLUTION_MEASURE_SUCCESS`
export const GET_EVOLUTION_MEASURE_FAILED = `${prefix}/GET_EVOLUTION_MEASURE_FAILED`
